import { IframeAction, StorageType } from "../types";
import { postMessageToIframe } from "../utils/internalStorageIframe";
import { safeLocalStorage, safeSessionStorage } from "./storage";

export const getIframeData = async (
  storageType: StorageType,
  key: string,
): Promise<string | undefined> =>
  postMessageToIframe({
    action: IframeAction.Get,
    storageType,
    key,
  }).then((result) => result as string | undefined);

export const updateStorageData = async (
  action: IframeAction,
  storageType: StorageType,
  key: string,
  value?: string,
): Promise<void> => {
  const storage =
    storageType === StorageType.Local ? safeLocalStorage : safeSessionStorage;
  if (action === IframeAction.Delete) {
    storage.remove(key);
  } else if (action === IframeAction.Set) {
    storage.set(key, value);
  }

  // update Iframe storage
  return postMessageToIframe({
    action,
    storageType,
    key,
    value,
  }).then(() => null); // ensures return type remains `Promise<void>`
};
